module.exports = __webpack_public_path__ + "static/il-employment-quality-job-security-poster-f9b6b953ebd6345b18e39da522ddb5b0.pdf";